import { action, makeObservable, observable } from 'mobx';

// just because observable.box doesn't wrap `.set()` with action
export class ValueBox<T> {
  _value: T;

  constructor(initialValue: T) {
    this._value = initialValue;

    makeObservable(this, {
      _value: observable.ref,
      set: action.bound,
    });
  }

  set(value: T) {
    this._value = value;
  }

  get value() {
    return this._value;
  }

  set value(value: T) {
    this.set(value);
  }
}
